import { render, staticRenderFns } from "./RecipientJob.vue?vue&type=template&id=bcebbe0e&"
import script from "./RecipientJob.vue?vue&type=script&lang=js&"
export * from "./RecipientJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports